module.exports = __webpack_public_path__ + "static/media/LeftBridgeFemale.5be1a3ca.svg";